// src/components/EmailVerificationPrompt.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext'; // Use your AuthContext
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../firebase'; // Import auth instance if needed for signout
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faExclamationTriangle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

function EmailVerificationPrompt() {
  const { currentUser } = useAuth();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResendVerification = async () => {
    setError('');
    setMessage('');
    if (!currentUser) {
      setError('Not logged in.');
      return;
    }

    setLoading(true);
    try {
      await sendEmailVerification(currentUser);
      setMessage('Verification email sent! Please check your inbox (and spam folder).');
    } catch (err) {
      console.error("Error sending verification email:", err);
      setError(`Failed to send verification email: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    auth.signOut();
    // Navigate to login or home page might happen automatically via AuthProvider listener
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card text-center shadow-sm border-warning">
            <div className="card-header bg-warning text-dark">
              <FontAwesomeIcon icon={faExclamationTriangle} className="me-2"/> Email Verification Required
            </div>
            <div className="card-body">
              <p className="card-text">
                Your email address (<strong>{currentUser?.email}</strong>) has not been verified.
              </p>
              <p>
                Please check your email inbox (and spam folder) for the verification link sent during signup. You need to verify your email before accessing the directory content.
              </p>
              {message && <div className="alert alert-success py-2 small"><FontAwesomeIcon icon={faCheckCircle} className="me-1"/> {message}</div>}
              {error && <div className="alert alert-danger py-2 small"><FontAwesomeIcon icon={faExclamationTriangle} className="me-1"/> {error}</div>}
              <button
                className="btn btn-primary mt-2"
                onClick={handleResendVerification}
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Resend Verification Email'}
              </button>
              <button
                className="btn btn-outline-secondary mt-2 ms-2"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
            <div className="card-footer text-muted small">
              If you've already verified, please try refreshing the page or logging out and back in.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailVerificationPrompt;